import { render, staticRenderFns } from "./footerView.vue?vue&type=template&id=3fc74664&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"
import style0 from "./footerView.vue?vue&type=style&index=0&id=3fc74664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc74664",
  null
  
)

export default component.exports